import { AutoTextarea, Field, ListEditor } from "./shared";
import { AlertTriangle, ListChecks, Target, Wrench, MessageSquare, History, ClipboardCheck } from "lucide-react";

const Section = (props) => {
  const { title, children, tone = "", testId } = props;
  const Icon = props.icon;
  return (
    <section className={`rounded-xl border p-3 space-y-2 ${tone}`} data-testid={testId}>
      <h4 className="text-sm font-semibold flex items-center gap-1.5"><Icon className="w-4 h-4" /> {title}</h4>
      {children}
    </section>
  );
};

export const BriefForm = ({ data, onChange }) => {
  const set = (k) => (v) => onChange({ ...data, [k]: v });
  return (
    <div className="space-y-3" data-testid="brief-form">
      <div className="rounded-xl border-2 border-primary/50 bg-primary/5 p-3">
        <label className="text-xs font-medium text-primary">Où en est le patient (1 phrase)</label>
        <AutoTextarea value={data.one_liner} onChange={set("one_liner")} rows={1} className="text-base font-medium bg-background mt-1" placeholder="Ex. Anxiété sociale en baisse, reprise des expositions après une rechute…" testId="brief-one-liner" />
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        <Section icon={History} title="Dernière séance" testId="brief-last-session"><AutoTextarea value={data.last_session} onChange={set("last_session")} rows={5} testId="brief-last-session-input" /></Section>
        <Section icon={ClipboardCheck} title="Travail personnel à revoir" testId="brief-homework"><AutoTextarea value={data.homework_review} onChange={set("homework_review")} rows={5} testId="brief-homework-input" /></Section>
        <Section icon={MessageSquare} title="Fils à reprendre" testId="brief-threads"><ListEditor value={data.open_threads} onChange={set("open_threads")} rows={4} testId="brief-threads-input" /></Section>
        <Section icon={AlertTriangle} title="Points de vigilance" tone={(data.vigilance || []).some(Boolean) ? "border-amber-300 bg-amber-50/50 dark:bg-amber-950/20" : ""} testId="brief-vigilance"><ListEditor value={data.vigilance} onChange={set("vigilance")} rows={4} placeholder="Aucun point de vigilance (ou un par ligne)" testId="brief-vigilance-input" /></Section>
        <Section icon={ListChecks} title="Ordre du jour proposé" testId="brief-agenda"><ListEditor value={data.agenda} onChange={set("agenda")} rows={4} testId="brief-agenda-input" /></Section>
        <div className="grid gap-3">
          <Section icon={Wrench} title="Techniques envisagées" testId="brief-techniques"><ListEditor value={data.techniques} onChange={set("techniques")} rows={2} testId="brief-techniques-input" /></Section>
          <Section icon={Target} title="Objectifs au premier plan" testId="brief-goals"><ListEditor value={data.goals_focus} onChange={set("goals_focus")} rows={2} testId="brief-goals-input" /></Section>
        </div>
      </div>
    </div>
  );
};

export const briefIsEmpty = (d) => !d || !Object.values(d).some((v) => (Array.isArray(v) ? v.some(Boolean) : !!v));
